module.exports = __webpack_public_path__ + "layout_SITC.766c541c1962d7df431bf6157bf87835.json";